// extracted by mini-css-extract-plugin
export default {"wrap":"Label_wrap__K570+","label":"Label_label__sOSxK","value":"Label_value__7ZsL-","border":"Label_border__Qicj4"};